import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AccordionModule} from 'primeng/components/accordion/accordion';

import './rxjs-operator-import';

// CLMTLK Imports
import { MessageListComponent } from './component/message-list/message-list.component';
import { MessageComponent } from './component/message-list/message/message.component';
import {StickyModule} from 'app/common/sticky/ng2-sticky-kit';
import { MenuBarComponent } from './component/menu-bar/menu-bar.component';


@NgModule({
  imports: [FormsModule, CommonModule, StickyModule, AccordionModule],
  declarations: [MessageListComponent, MessageComponent, MenuBarComponent],
  exports: [MessageListComponent, MessageComponent, MenuBarComponent]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/shared/shared.module.ts